import React, { useMemo } from 'react';

import { useApplicationContext } from '../../../../../shared/utils/applicationContext';
import { OfferContext } from '../../context';
import { AuctionContextProvider } from '../../context/AuctionContext';
import { IOfferCardFragmentProps } from '../../types/offer-card';
import { combineComputedProps } from '../../utils/computedProps/combineComputedProps';
import { OfferCardContainer } from './OfferCardContainer';

export function OfferContainer(props: IOfferCardFragmentProps) {
  const ctx = useApplicationContext();

  const computedProps = useMemo(() => combineComputedProps(props, ctx), [props, ctx]);

  const context = useMemo(
    () => ({
      // пропсы переданные фрагменту
      ...props,
      // вычисляемые свойства на основе переданных пропсов
      ...computedProps,
    }),
    [props, computedProps],
  );

  return (
    <OfferContext.Provider value={context}>
      <AuctionContextProvider {...props}>
        <OfferCardContainer />
      </AuctionContextProvider>
    </OfferContext.Provider>
  );
}
